import { get, isObject } from 'lodash';
import moment from 'moment';

const attemptJsonParse = data => {
  try {
    return JSON.parse(data);
  } catch (err) {
    return data;
  }
};

// Normalize data for rendering
export const formatActivityLogs = logs => {
  return logs.map(log => {
    const request = get(log, 'request', null);
    let requestBody = attemptJsonParse(get(request, 'body', null));
    const response = get(log, 'response', null);
    let responseBody = attemptJsonParse(get(response, 'body', null));

    if (get(responseBody, 'message')) {
      responseBody = attemptJsonParse(responseBody.message);
    }
    if (get(responseBody, 'body')) {
      responseBody = attemptJsonParse(responseBody.body);
    }

    let requestMessage = isObject(requestBody) ? null : requestBody;
    let responseMessage = isObject(responseBody) ? null : responseBody;

    const timestamp = get(request, 'timestamp', '');
    const formattedTimestamp = timestamp
      ? moment(timestamp).format('MM/DD/YY h:mmA')
      : '';

    return {
      ...log,
      request: {
        ...request,
        user: get(request, 'user', ''),
        method: get(request, 'method', ''),
        body: requestBody ? requestBody : {},
        message: requestMessage,
        timestamp: formattedTimestamp,
        url: get(request, 'url', '')
      },
      response: {
        ...response,
        body: responseBody ? responseBody : {},
        message: responseMessage,
        status: get(response, 'status', '')
      }
    };
  });
};
